
import {
  Modal,

  Button,

} from "antd";
import { FaFileInvoiceDollar } from "react-icons/fa";
import {

  PrinterOutlined,
} from "@ant-design/icons";

// ─── PDF Invoice Printer ─────────────────────────────────────────────────────
export const printInvoicePDF = (invoiceData, booking) => {
  const {
    visitPrice = 0,
    services = [],
    discountAmount = 0,
    discountPer = 0,
    paidAmount = 0,
  } = invoiceData || {};

  const servicesTotal = services.reduce(
    (sum, s) => sum + s.unitPrice * s.quantity,
    0
  );
  const subtotal = visitPrice + servicesTotal;
  const percentDiscount = (subtotal * discountPer) / 100;
  const totalDiscount = discountAmount + percentDiscount;
  const total = Math.max(0, subtotal - totalDiscount);
  const remaining = Math.max(0, total - paidAmount);

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const serviceRows = services
    .map(
      (s) => `
        <tr>
            <td style="padding: 10px 14px; border-bottom: 1px solid #f0e8d0; font-size: 13px; color: #3a2e1e;">${s.title || s.externalServiceTitle || "Service"}</td>
            <td style="padding: 10px 14px; border-bottom: 1px solid #f0e8d0; text-align: center; font-size: 13px; color: #3a2e1e;">${s.quantity}</td>
            <td style="padding: 10px 14px; border-bottom: 1px solid #f0e8d0; text-align: right; font-size: 13px; color: #3a2e1e;">EGP ${Number(s.unitPrice).toFixed(2)}</td>
            <td style="padding: 10px 14px; border-bottom: 1px solid #f0e8d0; text-align: right; font-size: 13px; font-weight: 600; color: #8B6914;">EGP ${(s.unitPrice * s.quantity).toFixed(2)}</td>
        </tr>
    `
    )
    .join("");

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Invoice – ${booking?.patientName || "Patient"}</title>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Jost:wght@300;400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Jost', sans-serif; background: #ffffff; color: #3a2e1e; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 0; position: relative; background: #ffffff; }
        .header { padding: 32px 48px 24px; display: flex; align-items: flex-start; justify-content: space-between; border-bottom: 2px solid #c9a84c; }
        .logo-section img { height: 90px; object-fit: contain; }
        .invoice-meta { text-align: right; }
        .invoice-meta .invoice-title { font-family: 'Cormorant Garamond', serif; font-size: 36px; font-weight: 700; color: #c9a84c; letter-spacing: 3px; text-transform: uppercase; line-height: 1; }
        .invoice-meta .invoice-number { font-size: 12px; color: #9a8060; letter-spacing: 1.5px; text-transform: uppercase; margin-top: 6px; }
        .gold-rule { height: 3px; background: linear-gradient(90deg, #c9a84c 0%, #f0d080 50%, #c9a84c 100%); }
        .patient-bar { background: #faf6ee; padding: 20px 48px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e8dfc8; }
        .patient-bar .label { font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #9a8060; margin-bottom: 4px; }
        .patient-bar .value { font-size: 16px; font-weight: 600; color: #3a2e1e; font-family: 'Cormorant Garamond', serif; }
        .patient-bar .booking-id { font-size: 12px; color: #9a8060; margin-top: 2px; }
        .body { padding: 32px 48px; }
        .section-title { font-family: 'Cormorant Garamond', serif; font-size: 13px; letter-spacing: 3px; text-transform: uppercase; color: #c9a84c; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8dfc8; }
        .visit-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0e8d0; }
        .visit-row .item-name { font-size: 13px; color: #3a2e1e; }
        .visit-row .item-amount { font-size: 13px; font-weight: 600; color: #8B6914; }
        .services-table { width: 100%; border-collapse: collapse; margin-top: 8px; }
        .services-table thead tr { background: linear-gradient(135deg, #c9a84c, #e8c96a); }
        .services-table thead th { padding: 10px 14px; font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #ffffff; font-weight: 600; text-align: left; }
        .services-table tbody tr:nth-child(even) { background: #faf6ee; }
        .totals-section { margin-top: 28px; display: flex; justify-content: flex-end; }
        .totals-box { width: 280px; border: 1px solid #e8dfc8; border-radius: 8px; overflow: hidden; }
        .totals-row { display: flex; justify-content: space-between; padding: 10px 16px; font-size: 13px; border-bottom: 1px solid #f0e8d0; }
        .totals-row:last-child { border-bottom: none; }
        .totals-row .tl { color: #9a8060; }
        .totals-row .tr { color: #3a2e1e; font-weight: 500; }
        .totals-row.discount .tl, .totals-row.discount .tr { color: #c0392b; }
        .totals-row.total-final { background: linear-gradient(135deg, #c9a84c, #e8c96a); padding: 14px 16px; }
        .totals-row.total-final .tl, .totals-row.total-final .tr { color: #ffffff; font-weight: 700; font-size: 15px; font-family: 'Cormorant Garamond', serif; }
        .totals-row.paid .tr { color: #27ae60; font-weight: 600; }
        .totals-row.remaining .tr { color: ${remaining > 0 ? "#e67e22" : "#27ae60"}; font-weight: 600; }
        .status-badge { display: inline-block; margin-top: 20px; padding: 8px 20px; border-radius: 24px; font-size: 12px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; background: ${remaining === 0 ? "#e8f8f0" : "#fef3e8"}; color: ${remaining === 0 ? "#27ae60" : "#e67e22"}; border: 1px solid ${remaining === 0 ? "#a9dfbf" : "#f0c070"}; }
        .footer { margin-top: 40px; padding: 24px 48px; border-top: 1px solid #e8dfc8; display: flex; justify-content: space-between; align-items: center; background: #faf6ee; }
        .footer .clinic-name { font-family: 'Cormorant Garamond', serif; font-size: 14px; font-weight: 700; color: #c9a84c; letter-spacing: 2px; text-transform: uppercase; }
        .footer .clinic-sub { font-size: 10px; color: #9a8060; letter-spacing: 1px; text-transform: uppercase; margin-top: 2px; }
        .footer .thank-you { font-family: 'Cormorant Garamond', serif; font-size: 15px; font-style: italic; color: #9a8060; }
        @media print { body { margin: 0; } .page { width: 100%; margin: 0; } }
    </style>
</head>
<body>
<div class="page">
    <div class="header">
        <div class="logo-section"><img src="./images/headerLogo.png" alt="Clinic Logo" onerror="this.style.display='none'"/></div>
        <div class="invoice-meta">
            <div class="invoice-title">Invoice</div>
            <div class="invoice-number">No. ${booking?.bookingCode ? "#" + booking.bookingCode : "#—"}</div>
            <div class="invoice-number" style="margin-top:4px;">${today}</div>
        </div>
    </div>
    <div class="gold-rule"></div>
    <div class="patient-bar">
        <div>
            <div class="label">Patient Name</div>
            <div class="value">${booking?.patientName || "—"}</div>
            ${booking?.bookingCode ? `<div class="booking-id">Booking #${booking.bookingCode}</div>` : ""}
        </div>
        <div style="text-align:right;">
            <div class="label">Date of Visit</div>
            <div class="value">${booking?.bookingDate ? new Date(booking.bookingDate).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }) : today}</div>
            ${booking?.clinicName ? `<div class="booking-id">${booking.clinicName}</div>` : ""}
        </div>
    </div>
    <div class="body">
        ${visitPrice > 0 ? `<div class="section-title">Consultation</div><div class="visit-row"><span class="item-name">Visit / Consultation Fee</span><span class="item-amount">EGP ${Number(visitPrice).toFixed(2)}</span></div>` : ""}
        ${services.length > 0 ? `
        <div class="section-title" style="margin-top:24px;">Services Provided</div>
        <table class="services-table">
            <thead><tr><th>Service</th><th style="text-align:center;">Qty</th><th style="text-align:right;">Unit Price</th><th style="text-align:right;">Total</th></tr></thead>
            <tbody>${serviceRows}</tbody>
        </table>` : ""}
        <div class="totals-section">
            <div class="totals-box">
                <div class="totals-row"><span class="tl">Subtotal</span><span class="tr">EGP ${subtotal.toFixed(2)}</span></div>
                ${totalDiscount > 0 ? `<div class="totals-row discount"><span class="tl">Discount${discountPer > 0 ? ` (${discountPer}%)` : ""}</span><span class="tr">− EGP ${totalDiscount.toFixed(2)}</span></div>` : ""}
                <div class="totals-row total-final"><span class="tl">Total Amount</span><span class="tr">EGP ${total.toFixed(2)}</span></div>
                <div class="totals-row paid"><span class="tl">Paid</span><span class="tr">EGP ${Number(paidAmount).toFixed(2)}</span></div>
                <div class="totals-row remaining"><span class="tl">Balance Due</span><span class="tr">EGP ${remaining.toFixed(2)}</span></div>
            </div>
        </div>
        <div><span class="status-badge">${remaining === 0 ? "✓ Fully Paid" : `Balance Due: EGP ${remaining.toFixed(2)}`}</span></div>
    </div>
    <div class="footer">
        <div><div class="clinic-name">Jood Clinic</div><div class="clinic-sub">Lymphoedema &amp; Cosmetic Clinic</div></div>
        <div class="thank-you">Thank you for your trust</div>
    </div>
</div>
<script>window.onload = function() { window.print(); }</script>
</body>
</html>`;

  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const blobUrl = URL.createObjectURL(blob);
  const patientSlug = (booking?.patientName || "Patient").replace(/\s+/g, "_");
  const dateSlug = new Date().toISOString().slice(0, 10);
  const filename = `Invoice_${patientSlug}_${dateSlug}.html`;
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.open(blobUrl, "_blank");
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
};

// ─── Print Confirmation Modal ────────────────────────────────────────────────
export const PrintConfirmModal = ({ visible, onPrint, onSkip, isMobile }) => (
  <Modal open={visible} footer={null} closable={false} centered width={isMobile ? "90vw" : 420}>
    <div className="text-center py-4">
      <div className="mx-auto mb-4 w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg">
        <PrinterOutlined className="text-white text-2xl" />
      </div>
      <h3 className="text-lg font-bold text-gray-800 mb-2">Invoice Created Successfully! 🎉</h3>
      <p className="text-gray-500 text-sm mb-6">Would you like to print a copy of this invoice?</p>
      <div className="flex gap-3 justify-center">
        <Button onClick={onSkip} size="large" className="rounded-xl min-w-[110px]">Skip</Button>
        <Button
          type="primary"
          size="large"
          icon={<PrinterOutlined />}
          onClick={onPrint}
          className="rounded-xl min-w-[130px]"
          style={{ background: "linear-gradient(135deg, #c9a84c, #e8c96a)", border: "none" }}
        >
          Print Invoice
        </Button>
      </div>
    </div>
  </Modal>
);